import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { FormControl } from '@angular/forms';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as moment from 'moment';
import { Store } from '@ngrx/store';
import * as fromCommonStore from '../../../store';
import * as fromRootStore from '../../../reducers';
import { AddTestingComponent } from './addTesting.component';
import { AddTrailComponent } from './addTrail.component';
import { AddServiceTestingComponent } from './addServiceTesting.component';
import { AddServiceEntryComponent } from './addServiceEntry.component';
import { TestingTrailModel } from '../../../model/index';
import { TestingTrailService, CommonService, SubscribeService } from '../../../services/index';
import { clientDocumentComponent } from '../../common/clientDocument.component';

@Component({
    selector: 'testingTrail-tab',
    templateUrl: './testingTrail.component.html',
})
export class TestingTrailComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;
    @Input('params') params: string;

    public pageType: string;
    public list: any[] = [];
    public testingdata: any[] = [];

    isLoadMask: Promise<any>;
    testingData: TestingTrailModel[];
    isLoading: boolean = false;

    viewTypeCtrl: FormControl;
    viewTypeList = [];
    files: any;
    name: any;
    client_id: any;
    warrantyList: any = ['Within Warranty', 'Out of Warranty', 'All'];
    branch:any;
    curBranch: any;
    userType: any;
    searchData: any;

    constructor(public store: Store<fromRootStore.State>, private testingTrailService: TestingTrailService, private modalService: BsModalService, public subscribeService: SubscribeService) {
        this.viewTypeCtrl = new FormControl();
        // this.viewTypeList = ['Analyse', 'Service','Send To Company','Courier Details','Receive From Company'];

        // TO GET USER TYPE
        this.store.select(fromCommonStore.getAuth).subscribe((auth: any) => {
            if (auth['islogin']) {
                this.curBranch = auth['branch_id'];
                this.userType = auth['usertype'];
            }
        });
        if(this.userType=='HV'){
            this.viewTypeList = ['Give To','Analyse', 'Service','Send To Company','Courier Details','Receive From Company','Delivery List'];
            this.searchData = 'Give To';
        } else {
            this.viewTypeList = ['Analyse', 'Service','Send To Company','Courier Details','Receive From Company','Receiving From Branch'];
            this.searchData = 'Analyse';
        }
    }

    loadingIndicator: boolean = true;
    reorderable: boolean = true;
    scrollTimeout: any;
    suppressPaging: boolean = false;

    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'date',
        orderDir: 'DESC'
    };

    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;
    columns = [];
    filterData = {
        "search_data": "Analyse",
        "srf_no": "",
        "from_date": new Date(),
        "to_date": new Date(),
        "warranty": "All"
    };

    ngOnInit(): void {
        let that = this;
        if ((this.params['tabParams'] == 'Trial') || (this.params['tabParams'] == 'Testing')) {
            this.columns = [
                { name: 'SNo', prop: 'sno', width: 70, minWidth: 70, maxWidth: 70, cellClass: 'cell-center', sortable: false, cellTemplate: this.snoTemplate },
                { name: 'WalkIn Date', prop: 'dispdate', width: 120, minWidth: 120, maxWidth: 120},
                { name: 'Client ID', prop: 'client_no', width: 100, minWidth: 100, maxWidth: 100 },
                { name: 'Name', prop: 'client_name', width: 150, minWidth: 150, maxWidth: 150 },
                { name: 'Reference', prop: 'name', width: 150, minWidth: 150, maxWidth: 150 },
                //{ name: 'Mobile', prop: 'mobile', width: 100, minWidth: 100, maxWidth: 100 },
                { name: 'Status', prop: 'status', width: 100, minWidth: 100, maxWidth: 100 },
                { name: 'Testing', prop: 'testing_details', width: 100, minWidth: 100, maxWidth: 100 },
                { name: 'Testing Description', prop: 'complaint', width: 180, minWidth: 180, maxWidth: 180 },
                { name: 'Trial Description', prop: 'trail_description', width: 180, minWidth: 180, maxWidth: 180 },
                { name: 'Option', prop: 'option', width: 130, minWidth: 130, maxWidth: 130, sortable: false, cellClass: 'cell-center', cellTemplate: this.editDeleteTemplate }
            ];
        } else if (this.params['tabParams'] == 'Service Testing') {
            this.columns = [
/*                 { name: 'SNo', prop: 'sno', width: 70, minWidth: 70, maxWidth: 70, cellClass: 'cell-center', sortable: false, cellTemplate: this.snoTemplate },*/
                { name: 'Service No', prop: 'bill_no', width: 110, minWidth: 110, maxWidth: 110 },
                { name: 'SRF No', prop: 'srf_no', width: 120, minWidth: 120, maxWidth: 120 },
                { name: 'Service Date', prop: 'service_walkin_date', width: 130, minWidth: 130, maxWidth: 130 },
                { name: 'From Branch', prop: 'from_branch_name', width: 140, minWidth: 140, maxWidth: 140 },
/*                 { name: 'Bill No', prop: 'sale_no', width: 120, minWidth: 120, maxWidth: 120 },
 */             { name: 'Client ID', prop: 'client_no', width: 130, minWidth: 130, maxWidth: 130 },
                { name: 'Name', prop: 'client_name', width: 140, minWidth: 140, maxWidth: 140 },
                { name: 'Mobile', prop: 'mobile', width: 120, minWidth: 120, maxWidth: 120 },
                { name: 'Machine Name', prop: 'model_name', width: 150, minWidth: 150, maxWidth: 150 },
                { name: 'Date', prop: 'disp_date', width: 120, minWidth: 120, maxWidth: 120},
                { name: 'Option', prop: 'option', width: 140, minWidth: 140, maxWidth: 140, sortable: false, cellTemplate: this.editDeleteTemplate }
            ];
        }

        this.pageCallback({ offset: 0 });
        this.subscribeService.publishReloadServiceTestGrid().subscribe(($e) => {
            that.pageCallback({ offset: 0 });
        });
    }

    /**
    * Called whenever the user changes page
    */
    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        if (this.suppressPaging && pageInfo.offset === this.page.offset) { return; }
        this.suppressPaging = false;
        this.page.offset = pageInfo.offset;
        this.getTestingList();
    }

    onScroll() {
        this.suppressPaging = true;
        if (this.scrollTimeout) {
            clearTimeout(this.scrollTimeout);
        }
        this.scrollTimeout = setTimeout(() => {
            this.suppressPaging = false;
        }, 100);
    }

    /**
   * Called whenever the user changes the sort order
   */
    sortCallback(sortInfo: { sorts: { dir: string, prop: string }[], column: {}, prevValue: string, newValue: string }) {
        // there will always be one "sort" object if "sortType" is set to "single"
        this.page.orderDir = sortInfo.sorts[0].dir;
        this.page.orderBy = sortInfo.sorts[0].prop;
        this.getTestingList();
    }
    onOpenedFilter(): void {
        setTimeout(function() {
            $('#filterTextBox').focus();
        }, 100);
    }
    //viewType AS search_data
    clearFilter(): void {
        this.filterData = {
            "search_data": this.searchData,
            "srf_no": "",
            "from_date": new Date(),
            "to_date": new Date(),
            "warranty": "All"
        };
        this.applyFilter();
    }
    applyFilter(): void {
        //this.filterExpand = false;
        this.filterPanel.close();
        this.getTestingList();
    }
    onChangePageSize(limit) {
        this.page.limit = limit;
        this.getTestingList();
    }

    getTestingList(): void {
        let params = {
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`,
            orderColumn: `${this.page.orderBy}`,
            orderDir: `${this.page.orderDir}`,
            page_from: this.params['tabParams'],
            srf_no: this.filterData['srf_no'],
            from_date: moment(this.filterData['from_date']).format('YYYY-MM-DD'),
            to_date: moment(this.filterData['to_date']).format('YYYY-MM-DD'),
            view_type: this.filterData['search_data']
        };
        if (this.params['tabParams'] =='Service Testing' && this.filterData['warranty'] != 'All') {
            params['warranty'] = this.filterData['warranty'];
        }
        if(this.filterData['warranty'] =='Within Warranty')
        {
            params['warranty']='Yes';
        }
        if(this.filterData['warranty'] =='Out of Warranty')
        {
            params['warranty']='No';
        }
        let that = this;
        this.isLoadMask = this.testingTrailService
            .getTestingList(params)
            .then(function(res: any) {
                that.loadingIndicator = false;
                that.page.count = res.totCnt;
                that.testingData = res.data;
                that.branch = res.branch;
            });
    }

    bsModalRef: BsModalRef;
    public onAddEditTestingTrail(row: any, btnType? :string): void {
        let that = this,
            pageType = this.params['tabParams'];
        row['page_from'] = pageType;
        row['is_edit'] = (btnType === 'edit') ? 'Yes' : 'No';
        if (pageType == 'Testing') {
            this.bsModalRef = this.modalService.show(AddTestingComponent, {
                keyboard: false,
                ignoreBackdropClick: true,
                class: 'modal-lg compWidth-90'
            });
            this.bsModalRef.content.testingdata = Object.assign({}, row);
        } else if (pageType == 'Trial') {
            this.bsModalRef = this.modalService.show(AddTrailComponent, {
                keyboard: false,
                ignoreBackdropClick: true,
                class: 'modal-lg compWidth-90'
            });
            this.bsModalRef.content.traildata = Object.assign({}, row);
        } else if (pageType == 'Service Testing') {
            this.bsModalRef = this.modalService.show(AddServiceTestingComponent, {
                keyboard: false,
                ignoreBackdropClick: true,
                class: 'modal-lg compWidth-70'
            });
            row['view_type']=this.filterData.search_data;
            row['btnType']=btnType;
            row['branch']=this.branch;
            this.bsModalRef.content.testingdata = Object.assign({}, row);
        }  

        this.bsModalRef.content.title = pageType + ' Details';
        this.bsModalRef.content.testingTrailLoadEvent.subscribe(($e) => {
            that.getTestingList();
        });
    }

    OnsaveEmployeeApproval(type: string,row: any): void {
        let that = this;
        let data = row
        data['status_type'] = type;
        this.isLoading = true;
        this.testingTrailService
        .saveEmployeeApproval(data)
        .then(function (res: any) {
            that.isLoading = false;
            if (res.success) {
                swal('SUCCESS', res.message, 'success');     
                that.getTestingList();
            } else {
                swal('ERROR', res.message, 'error');
            }
        })
        .catch(function (error: any) {
            that.isLoading = false;
            let res = JSON.parse(error._body);
            swal('ERROR', res.message, 'error');
            //console.log(error);
        });
        
    }

    public onAddEditService(mode: string, row: any, btnType : string): void {
        let that = this;
        if (mode == "Edit") {
            row['mode'] = mode;
            row['btnType']=btnType;
        }
        that.subscribeService.subScribeTabID('Transaction', 'AddServiceEntryComponent', row, 'serviceEntry');
    }
    open(row) {
        let data = {
            client_id: row.client_id,
        }
        this.bsModalRef = this.modalService.show(clientDocumentComponent, {
            keyboard: false,
            ignoreBackdropClick: true,
            class: 'modal-lg compWidth-40'
        });
        this.bsModalRef.content.getPopUp = data;
    }

    onConfirmTrialNotWilling(row: any): void {
        let that = this;
        swal({
            title: 'Confirm Trial Not Willing',
            text: `Are you sure you want to confirm "Trial Not Willing" for ${row.client_name} (${row.client_no})?`,
            type: 'question',
            showCancelButton: true,
            confirmButtonText: 'Yes, Confirm',
            confirmButtonClass: 'btn-success',
            cancelButtonText: 'No, Edit',
            cancelButtonClass: 'btn-warning'
        }).then(function(result) {
            if (result) {
                // User clicked "Yes, Confirm" - process Trial Not Willing logic
                that.isLoading = true;
                let confirmData = {
                    walkin_id: row.walkin_id,
                    client_id: row.client_id,
                    testing: 'Trial Not Willing',
                    action: 'confirm_trial_not_willing'
                };

                that.testingTrailService
                    .confirmTrialNotWilling(confirmData)
                    .then(function (res: any) {
                        that.isLoading = false;
                        if (res.success) {
                            swal('SUCCESS', res.message, 'success');
                            that.getTestingList(); // Refresh the list
                        } else {
                            swal('ERROR', res.message, 'error');
                        }
                    })
                    .catch(function (error: any) {
                        that.isLoading = false;
                        let res = JSON.parse(error._body);
                        swal('ERROR', res.message, 'error');
                    });
            }
        }, function(dismiss) {
            if (dismiss === 'cancel') {
                // User clicked "No, Edit" - open the testing edit form
                that.onAddEditTestingTrail(row);
            }
            // If user clicks outside or presses Escape, do nothing
        });
    }

    onTrialNotWilling(row: any): void {
        let that = this;
        swal({
            title: 'Trial Not Willing',
            text: `Mark "${row.client_name} (${row.client_no})" as "Trial Not Willing"? This will remove the record from the Trial list.`,
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, Mark as Not Willing',
            confirmButtonClass: 'btn-danger',
            cancelButtonText: 'Cancel',
            cancelButtonClass: 'btn-secondary'
        }).then(function(result) {
            if (result) {
                // User confirmed - call backend to mark as Trial Not Willing
                that.isLoading = true;
                let trialNotWillingData = {
                    walkin_id: row.walkin_id,
                    client_id: row.client_id,
                    action: 'mark_trial_not_willing'
                };

                that.testingTrailService
                    .markTrialNotWilling(trialNotWillingData)
                    .then(function (res: any) {
                        that.isLoading = false;
                        if (res.success) {
                            swal('SUCCESS', res.message, 'success');
                            that.getTestingList(); // Refresh the list
                        } else {
                            swal('ERROR', res.message, 'error');
                        }
                    })
                    .catch(function (error: any) {
                        that.isLoading = false;
                        let res = JSON.parse(error._body);
                        swal('ERROR', res.message, 'error');
                    });
            }
        }, function() {
            // User cancelled - do nothing
        });
    }

}




// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/testingTrail/testingTrail.component.ts